export default "__VITE_ASSET__BS4uTxgV__"